







































import {
  PackageDashboardApi,
  PackageForDashboardPoliciesToolsAndEquipment,
  PolicyForDashboard,
  PolicyType,
} from '@/api';
import BiFormView from '@/components/bi-form-view/bi-form-view.vue';
import Vue from '@/vue';
import { PropType } from 'vue';
import Component from 'vue-class-component';

@Component
export default class DashboardPolicyMdtView extends Vue.extend({
  props: {
    data: {
      type: Object as PropType<PackageForDashboardPoliciesToolsAndEquipment>,
    },
    complete: {
      type: Boolean,
      required: true,
      default: false,
    },
    showPremium: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
}) {
  get toolsAndEquipmentRenewing(): boolean {
    return (
      this.data.toolsAndEquipment?.id !== undefined &&
      this.data.toolsAndEquipment.id !== null &&
      this.data.isRenewal === true
    );
  }

  get isPaid(): boolean {
    return this.data?.isPayable === false || false;
  }

  get underwriting(): boolean {
    return this.data.toolsAndEquipment?.status === 'Underwriting-Insurer'
      || this.data.toolsAndEquipment?.status === 'Underwriting-Client'
      || this.data.toolsAndEquipment?.status === 'Underwriting-outside scheme'
  }

  get completeFormLabel(): string {
    return this.toolsAndEquipmentRenewing
      ? 'Confirm details to renew policy'
      : 'Complete form to add policy';
  }

  onToolsAndEquipmentIsInsuredChanged(to: boolean): void {
      this.save();
  }
  onToolsAndEquipmentCoverOfChanged(value: PolicyForDashboard): void {
      this.save();
  }

  open(): void {
    (this.$refs.formView as BiFormView).open();
  }

  saving = false;
  async save(): Promise<void> {
    if (this.data?.toolsAndEquipment !== undefined) {
      this.saving = true;
      try {
        this.$emit(
          'update',
          (
            await new PackageDashboardApi().patchPackageDashboardPolicy(
              this.$packageHash,
              PolicyType.Mdt,
              {
                data: this.data.toolsAndEquipment,
              }
            )
          ).data.data
        );
      } catch (err) {
        console.error(err);
      } finally {
        this.saving = false;
      }
    }
  }
}
